<div class="controls-panel">
  <div class="title">
    <h3>Services <i [style]="{opacity: loading ? 1 : 0}" class="fas fa-sync fa-spin text-muted title-spinner"></i></h3>
  </div>
  <div class="controls">
    <a [tooltip]="'View all tests created directly from the platform interface.'" [tooltipPlacement]="'top'" class="btn btn-sm"
      [ngClass]="{'btn-link': chartItems === 'ui', 'btn-default': chartItems !== 'ui'}" (click)="setChartItems('ui')" type="button">UI</a>
    <a [tooltip]="'View all tests created via the API.'" [tooltipPlacement]="'top'" class="btn btn-sm"
      [ngClass]="{'btn-link': chartItems === 'api', 'btn-default': chartItems !== 'api'}" (click)="setChartItems('api')" type="button">API</a>
  </div>
</div>
<div #chartContainer>
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="setChart($event)"></highcharts-chart>
</div>
